import React from "react";
import { ResultsProps } from "@usereactify/search";

type Props = React.ComponentProps<NonNullable<ResultsProps["renderResultCardCallout"]>>;

export const ResultCardCallout: React.FC<Props> = (props) => {
  const { callout } = props;

  return callout ? (
    <article className={`product-card`}>
      <a href={callout?.link} className="product-card__img-wrapper relative">
        <div className="product-card__img">
          {callout?.desktopImage && <img className="motion-reduce hide-mobile" src={callout.desktopImage} />}
          {callout?.mobileImage && <img className="motion-reduce hide-desktop" src={callout.mobileImage} />}
        </div>
      </a>
    </article>
  ) : null;
};
